import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalDirective, BsModalRef } from 'ngx-bootstrap/modal';
import { BackendApiService } from '../services/backend-api.service';
import { BackendSocketService } from '../services/backend-socket.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CommonService } from '../services/common.service';
import _ from 'lodash';
import { NgForm } from '@angular/forms';
import { interval } from 'rxjs';
import * as $ from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import * as jspdf from 'jspdf';
import * as moment from 'moment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-badlaorderdetail',
  templateUrl: './badlaorderdetail.component.html',
  styleUrls: ['./badlaorderdetail.component.scss'],
})
export class BadlaorderdetailComponent implements OnInit {
  @ViewChild('deleteModal') deleteModal: ModalDirective;
  @ViewChild('orderModal') orderModal: ModalDirective;
  @ViewChild('content') content: ElementRef;

  endOrder: Boolean = true;
  badlaOrderList = [];
  scriptFilter = [];
  filterBadla = [];
  overAllResult: any = 0;
  userId = localStorage.getItem('userId');
  selectedBadla = '1';
  resultPl;
  badlaInstrument = [];
  badlaRecord = [];
  mcxBadlaInstrument = [];
  comexBadlaInstrument = [];
  dgcxBadlaInstrument = [];
  allComexInstrument = [];
  allMcxInstrument = [];
  allDgcxInstrument = [];
  isBrokrageCheck = false;
  isEndClosingRate = false;
  filter = {
    mcxbadlaInst: null,
    mcxType: null,
    mcxQty: null,
    mcxPrice: null,
    mcxBroType: null,
    mcxBroAmount: null,
    dgcxbadlaInst: null,
    dgcxType: null,
    dgcxQty: null,
    dgcxPrice: null,
    dgcxBroType: null,
    dgcxBroAmount: null,
    comexbadlaInst: null,
    comexType: null,
    comexQty: null,
    comexPrice: null,
    comexBroType: null,
    comexBroAmount: null,
    type: null,
    id: null,
    duty: null,
    reference: null,
    endandopen: null,
    openingAmount: '0',
    mcxRolloverbadlaInst: null,
    mcxRolloverType: null,
    mcxRolloverQty: null,
    mcxRolloverPrice: null,
    mcxRolloverBroType: null,
    mcxRolloverBroAmount: null,
    comexRolloverbadlaInst: null,
    comexRolloverType: null,
    comexRolloverQty: null,
    comexRolloverPrice: null,
    comexRolloverBroType: null,
    comexRolloverBroAmount: null,
    dgcxRolloverbadlaInst: null,
    dgcxRolloverType: null,
    dgcxRolloverQty: null,
    dgcxRolloverPrice: null,
    dgcxRolloverBroType: null,
    dgcxRolloverBroAmount: null,
    orderId: null,
  };
  Toast = {
    type: '',
    title: '',
    timeout: 0,
    body: '',
  };
  closingRate;
  settlementType = '1';
  delId;
  delOrderId;
  isLast = false;
  totalPlCnt = 0;
  badlaTitle: any;
  jsonData: any = [];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private backendApiService: BackendApiService,
    private backendSocketService: BackendSocketService,
    private commonService: CommonService,
    private spinnerService: NgxSpinnerService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (params) {
        this.getBadlaOrder(params['detailId']);
      }
    });

    this.getPL();
  }

  getBadlaOrder(badlaId) {
    let data = {
      isOpen: false,
      userId: this.userId,
      filterId: badlaId,
    };
    this.backendApiService.badlaReport(data).subscribe((response) => {
      if (response.status == true) {
        this.badlaOrderList = response.data;
        this.resultPl = response.resultPl;
        // this.filterBadla = response.data;
        // this.scriptFilter = _.uniqBy(this.badlaOrderList, 'badlRefId');
        let sno = 0;
        let eleCnt = 0;
        this.badlaOrderList.forEach((element) => {
          eleCnt = eleCnt + 1;
          if (element['type'] == 'pl') {
            let elementObj = element['badlaDetail']['0'];
            // this.badlaTitle = elementObj['']
            let comexSellPrice =
              elementObj['endComexType'] == 'sell'
                ? Number(elementObj['endComexPrice'])
                : Number(elementObj['comexPrice']);
            let comexBuyPrice =
              elementObj['endComexType'] == 'sell'
                ? Number(elementObj['comexPrice'])
                : Number(elementObj['endComexPrice']);
            let comexQty = Number(elementObj['comexQty']);
            let comexLotSize = Number(elementObj['comexDetail'][0]['lot_size']);
            let endDgcxPrice = Number(elementObj['endDgcxPrice']);

            let comexEqu =
              (comexSellPrice - comexBuyPrice) * comexQty * comexLotSize;
            let comexResult = (comexEqu * 10000) / endDgcxPrice;
            element.comexResult = comexResult.toFixed(2);

            let mcxSellPrice =
              elementObj['endMcxType'] == 'sell'
                ? Number(elementObj['endMcxPrice'])
                : Number(elementObj['mcxPrice']);
            let mcxBuyPrice =
              elementObj['endMcxType'] == 'sell'
                ? Number(elementObj['mcxPrice'])
                : Number(elementObj['endMcxPrice']);
            let mcxQty = Number(elementObj['mcxQty']);
            let mcxLotSize = Number(elementObj['mcxDetail'][0]['lot_size']);
            let mcxResult = (mcxSellPrice - mcxBuyPrice) * mcxQty * mcxLotSize;
            element.mcxResult = mcxResult.toFixed(2);

            let dgcxSellPrice =
              elementObj['endDgcxType'] == 'sell'
                ? Number(elementObj['endDgcxPrice'])
                : Number(elementObj['dgcxPrice']);
            let dgcxBuyPrice =
              elementObj['endDgcxType'] == 'sell'
                ? Number(elementObj['dgcxPrice'])
                : Number(elementObj['endDgcxPrice']);
            let dgcxQty = Number(elementObj['dgcxQty']);
            let dgcxLotSize = Number(elementObj['dgcxDetail'][0]['lot_size']);
            let dgcxEqu =
              (dgcxSellPrice - dgcxBuyPrice) * dgcxQty * dgcxLotSize;
            let dgcxResult = (dgcxEqu * 10000) / endDgcxPrice;
            element.dgcxResult = dgcxResult.toFixed(2);
            let sum = comexResult + mcxResult + dgcxResult;
            element.totalResult = sum.toFixed(2);
            sno = sno + 1;
            element['sno'] = sno;
          }
          if (element['type'] == 'partialOrder') {
            sno = sno + 1;
            element['sno'] = sno;
          }
          if (element['type'] == 'brokerage') {
            element.amount = element['amount'].toFixed(2);
            element.comexbro = element['comexbro'].toFixed(2);
            element.mcxbro = element['mcxbro'].toFixed(2);
            element.dgcxbro = element['dgcxbro'].toFixed(2);
            // if(element.badlaDetail['length'] > 0){
            //   console.log('element++++++++++++',element.badlaDetail);
            // }
          }

          if (eleCnt == this.badlaOrderList.length) {
            this.totalPlCnt = sno;
          }
        });
      } else {
        this.badlaOrderList = [];
      }
    });

    let reqObj = {
      id: badlaId,
    };
    this.backendApiService.getBadlaOrderUniqId(reqObj).subscribe((response) => {
      if (response.status == true) {
        this.badlaTitle =
          response['data']['reference'] +
          ' [' +
          response['data']['settingName'] +
          '] ';
      }
    });
  }

  getPL() {
    let data = {
      isOpen: false,
      userId: this.userId,
    };
    this.backendApiService.getOrderPL(data).subscribe((response) => {
      if (response.status == true) {
        this.overAllResult = Number(response.data).toFixed(2);
      }
    });
  }

  searchBadlaScript() {
    if (this.selectedBadla) {
      let badlaId = this.selectedBadla;
      if (badlaId !== '1') {
        this.filterBadla = _.filter(this.badlaOrderList, function (dt) {
          return dt.badlRefId == badlaId;
        });
      } else {
        this.filterBadla = this.badlaOrderList;
      }
      this.filterBadla.forEach((element) => {
        let comexSellPrice =
          element['endComexType'] == 'sell'
            ? Number(element['endComexPrice'])
            : Number(element['comexPrice']);
        let comexBuyPrice =
          element['endComexType'] == 'sell'
            ? Number(element['comexPrice'])
            : Number(element['endComexPrice']);
        let comexQty = Number(element['comexQty']);
        let comexLotSize = Number(element['comexDetail'][0]['lot_size']);
        let endDgcxPrice = Number(element['endDgcxPrice']);
        let comexEqu =
          (comexSellPrice - comexBuyPrice) * comexQty * comexLotSize;
        let comexResult = (comexEqu * 10000) / endDgcxPrice;
        element.comexResult = comexResult.toFixed(2);

        let mcxSellPrice =
          element['endMcxType'] == 'sell'
            ? Number(element['endMcxPrice'])
            : Number(element['mcxPrice']);
        let mcxBuyPrice =
          element['endMcxType'] == 'sell'
            ? Number(element['mcxPrice'])
            : Number(element['endMcxPrice']);
        let mcxQty = Number(element['mcxQty']);
        let mcxLotSize = Number(element['mcxDetail'][0]['lot_size']);
        let mcxResult = (mcxSellPrice - mcxBuyPrice) * mcxQty * mcxLotSize;
        element.mcxResult = mcxResult.toFixed(2);

        let dgcxSellPrice =
          element['endDgcxType'] == 'sell'
            ? Number(element['endDgcxPrice'])
            : Number(element['dgcxPrice']);
        let dgcxBuyPrice =
          element['endDgcxType'] == 'sell'
            ? Number(element['dgcxPrice'])
            : Number(element['endDgcxPrice']);
        let dgcxQty = Number(element['dgcxQty']);
        let dgcxLotSize = Number(element['dgcxDetail'][0]['lot_size']);
        let dgcxEqu = (dgcxSellPrice - dgcxBuyPrice) * dgcxQty * dgcxLotSize;
        let dgcxResult = (dgcxEqu * 10000) / endDgcxPrice;
        element.dgcxResult = dgcxResult.toFixed(2);
        let sum = comexResult + mcxResult + dgcxResult;
        element.totalResult = sum.toFixed(2);
      });
      let data = {
        isOpen: false,
        userId: this.userId,
        badlRefId: badlaId !== '1' ? badlaId : null,
      };
      this.backendApiService.getOrderPL(data).subscribe((response) => {
        if (response.status == true) {
          this.overAllResult = Number(response.data).toFixed(2);
        }
      });
    }
  }

  editBadlaModal(id, orderId, isLast) {
    let orderDetail = _.find(this.badlaOrderList, function (o) {
      return o._id == orderId;
    });
    // console.log('orderDetail++++++++++',orderDetail);
    // console.log('badlaOrder++++++++++++++',this.badlaOrderList);
    // this.clearAllOpenModal();

    $('#dgcxRateId').html('');
    $('#mcxRateId').html('');
    $('#comexRateId').html('');

    this.spinnerService.show();
    this.endOrder = true;
    let data = {
      isActive: true,
    };
    this.backendApiService
      .liveBadlaInstruments(data)
      .subscribe((responseLive) => {
        if (responseLive.status == true) {
          this.badlaInstrument = responseLive.data;
        }
      });

    let filterData = {
      userId: 1,
    };
    this.backendApiService
      .badlaInstruments(filterData)
      .subscribe((responseBadlaInst) => {
        this.spinnerService.hide();
        if (responseBadlaInst.status == true) {
          this.badlaRecord = responseBadlaInst.data;
          var grpBadla = _.groupBy(this.badlaRecord, 'exchange');
          this.mcxBadlaInstrument = grpBadla['MCX'];
          this.comexBadlaInstrument = grpBadla['COMEX'];
          this.dgcxBadlaInstrument = grpBadla['DGCX'];
        }
        let reqObj = {
          id: id,
        };
        this.backendApiService
          .getSingleBadlaOrder(reqObj)
          .subscribe((response) => {
            if (response.status == true) {
              this.filter.comexbadlaInst = response['data']['comexbadlaInst'];
              this.filter.mcxbadlaInst = response['data']['mcxbadlaInst'];
              this.filter.dgcxbadlaInst = response['data']['dgcxbadlaInst'];
              this.filter.mcxType = orderDetail['badlaDetail'][0]['endMcxType'];
              this.filter.dgcxType =
                orderDetail['badlaDetail'][0]['endDgcxType'];
              this.filter.comexType =
                orderDetail['badlaDetail'][0]['endComexType'];
              this.filter.mcxQty = response['data']['mcxQty'];
              this.filter.dgcxQty = response['data']['dgcxQty'];
              this.filter.comexQty = response['data']['comexQty'];
              this.filter.mcxPrice =
                orderDetail['badlaDetail'][0]['endMcxPrice'];
              this.filter.dgcxPrice =
                orderDetail['badlaDetail'][0]['endDgcxPrice'];
              this.filter.comexPrice =
                orderDetail['badlaDetail'][0]['endComexPrice'];
              this.filter.type = response['data']['type'];
              this.filter.id = response['data']['_id'];
              this.filter.reference = response['data']['reference'];
              this.filter.duty = response['data']['duty'];
              this.filter.duty = response['data']['duty'];
              this.isBrokrageCheck = response['data']['checkBrokrage'];
              this.filter.mcxBroAmount = response['data']['mcxBroAmount'];
              this.filter.mcxBroType = response['data']['mcxBroType'];
              this.filter.comexBroAmount = response['data']['comexBroAmount'];
              this.filter.comexBroType = response['data']['comexBroType'];
              this.filter.dgcxBroAmount = response['data']['dgcxBroAmount'];
              this.filter.dgcxBroType = response['data']['dgcxBroType'];
              this.filter.openingAmount = response['data']['openingAmount'];
              this.filter.endandopen = response['data']['settledBadlaType'];
              this.filter.orderId = orderId;
              this.isLast = isLast;
              console.log(response['data']['settledBadlaType']);
              if (response['data']['settledBadlaType'] == '1') {
                if (response['data']['endClearingCheck'] == true) {
                  this.isEndClosingRate = true;
                  this.closingRate = response['data']['dollerClearingRate'];
                }
              } else if (response['data']['settledBadlaType'] == '3') {
                this.settlementType = '3';
                this.closingRate = response['data']['dollerClearingRate'];
              }
              setTimeout(() => {
                this.orderModal.show();
              }, 500);
            }
          });
      });
  }
  deleteBadlaModal(id, orderId) {
    this.delId = id;
    this.delOrderId = orderId;
    this.deleteModal.show();
  }

  settlementTypeChnage(id) {
    this.backendApiService.getDoller(1).subscribe((dollerRate) => {
      if (dollerRate['status'] == 1) {
        this.closingRate = dollerRate['data']['dollerRate'];
      }
    });
    this.settlementType = id;
  }

  chnageInsrument(instrumentToken, id) {
    if (instrumentToken[0] != 0) {
      let totalInstrument = [instrumentToken + '_full'];
      this.backendApiService
        .getLastPrice(totalInstrument)
        .subscribe((badlaLatestRate) => {
          if (
            badlaLatestRate['status'] == true &&
            badlaLatestRate['data'].length > 0
          ) {
            let badlaRateRes = _.map(
              badlaLatestRate['data'],
              function (resIns) {
                return JSON.parse(resIns);
              },
            );

            let price =
              badlaRateRes[0]['buy_price_0'] +
              ' | ' +
              badlaRateRes[0]['sell_price_0'];
            $('#' + id).html(price);
            $('#' + id + 'Rollover').html(price);
          }
        });
    } else {
      $('#' + id).html('');
    }
  }

  badlaScriptChnage(id) {
    let badlaDuty = _.find(this.badlaInstrument, function (o) {
      return o._id == id;
    });
    if (badlaDuty) {
      this.filter['duty'] = badlaDuty['settingValue'][0]['Duty'];
      let badlaType = badlaDuty['badlaType'] ? badlaDuty['badlaType'] : null;
      if (badlaType) {
        let filterComex = [];
        _.map(this['allComexInstrument'], function (resIns) {
          let position = -1;
          if (badlaType == 'GOLD') {
            position = resIns['name'].search(/gold/i);
          }
          if (badlaType == 'SILVER') {
            position = resIns['name'].search(/silver/i);
          }
          if (badlaType == 'COPPER') {
            position = resIns['name'].search(/copper/i);
          }
          if (badlaType == 'CRUDE') {
            position = resIns['name'].search(/crude/i);
          }

          if (position == 0) {
            filterComex.push(resIns);
          }
        });
        this['comexBadlaInstrument'] = filterComex;

        let filterMcx = [];
        _.map(this['allMcxInstrument'], function (resIns) {
          let position = -1;
          if (badlaType == 'GOLD') {
            position = resIns['name'].search(/gold/i);
          }
          if (badlaType == 'SILVER') {
            position = resIns['name'].search(/silver/i);
          }
          if (badlaType == 'COPPER') {
            position = resIns['name'].search(/copper/i);
          }
          if (badlaType == 'CRUDE') {
            position = resIns['name'].search(/crude/i);
          }

          if (position == 0) {
            filterMcx.push(resIns);
          }
        });
        this['mcxBadlaInstrument'] = filterMcx;
      } else {
        this['comexBadlaInstrument'] = this['allComexInstrument'];
        this['mcxBadlaInstrument'] = this['allMcxInstrument'];
        this['dhcxBadlaInstrument'] = this['allDgcxInstrument'];
      }
    }
  }

  comexTypeChnage() {
    if (this.filter.comexType == 'buy') {
      this.filter.mcxType = 'sell';
      this.filter.dgcxType = 'sell';
    } else if (this.filter.comexType == 'sell') {
      this.filter.mcxType = 'buy';
      this.filter.dgcxType = 'buy';
    } else {
      this.filter.mcxType = '';
      this.filter.dgcxType = '';
    }
  }

  checkBrokrage(check) {
    this.isBrokrageCheck = check;
  }

  createBadlaOrder() {
    if (this.filter.endandopen == '1' && this.isEndClosingRate == true) {
      this.filter['closingRate'] = this.closingRate;
    }
    this.backendApiService
      .editSettleBadlaOrder(this.filter)
      .subscribe((response) => {
        this.showToster('Success', 'success', 'Settled Successfully...');
        location.reload();
      });
  }

  closeModal() {
    this.clearRate();
    this.orderModal.hide();
  }
  clearRate() {
    $('#dgcxRateId').html('');
    $('#mcxRateId').html('');
    $('#comexRateId').html('');
    this.closingRate = null;
    this.settlementType = '';
  }

  checkEndClosing(check) {
    this.isEndClosingRate = check;
  }

  clearBadlaScript() {}

  closeDeleteBadlaOrder() {
    this.deleteModal.hide();
  }

  deleteBadlaOrder() {
    let data = {
      userId: this.userId,
      delId: this.delId,
      orderId: this.delOrderId,
    };
    this.backendApiService
      .deleteSettleBadlaOrder(data)
      .subscribe((response) => {
        if (response['status'] == true) {
          this.showToster('Success', 'success', 'Delete Successfully...');
          location.reload();
        } else {
          this.showToster('Error', 'error', 'Error In Delete...');
        }
      });
  }

  clearAllOpenModal() {
    this.deleteModal.show();
  }

  showToster(title, type, message) {
    this.Toast.title = title;
    this.Toast.type = type;
    this.Toast.body = message;
    this.commonService.popToast(type, title, 1500, message);
  }

  downloadAsPDF() {
    try {
      this.spinnerService.show();
      const element = document.getElementById('htmlData');

      if (!element) {
        this.showToster('Error', 'error', 'Table element not found');
        this.spinnerService.hide();
        return;
      }

      // Create a wrapper to include title and content
      const wrapper = document.createElement('div');
      wrapper.style.padding = '20px';
      wrapper.style.backgroundColor = 'white';
      wrapper.style.fontFamily = 'Arial, sans-serif';

      // Add title
      const titleDiv = document.createElement('div');
      titleDiv.innerHTML = `
        <h2 style="color: #0066cc; margin: 0 0 10px 0; font-size: 20px;">Settlement Report</h2>
        <p style="margin: 0 0 10px 0; font-size: 12px; color: #333;">Badla: ${this.badlaTitle || ''}</p>
        <hr style="border: none; border-top: 2px solid #0066cc; margin: 10px 0;">
      `;
      wrapper.appendChild(titleDiv);

      // Clone the table
      const tableClone = element.cloneNode(true) as HTMLElement;

      // Style the table
      const table = tableClone.querySelector('table');
      if (table) {
        table.style.width = '100%';
        table.style.borderCollapse = 'collapse';
        table.style.fontSize = '12px';
      }

      // Style header cells
      const headerCells = tableClone.querySelectorAll('thead th');
      headerCells.forEach((cell) => {
        const thElement = cell as HTMLElement;
        thElement.style.backgroundColor = '#00BCD4';
        thElement.style.color = 'white';
        thElement.style.padding = '8px';
        thElement.style.textAlign = 'left';
        thElement.style.fontWeight = 'bold';
        thElement.style.border = '1px solid #00BCD4';
      });

      // Style body cells
      const bodyCells = tableClone.querySelectorAll('tbody td');
      bodyCells.forEach((cell, index) => {
        const tdElement = cell as HTMLElement;
        tdElement.style.padding = '6px 8px';
        tdElement.style.border = '1px solid #333';
        tdElement.style.backgroundColor = '#1a1a1a';
        tdElement.style.color = '#ffffff';

        // Right align the amount column
        const cellIndex = index % 3;
        if (cellIndex === 2) {
          tdElement.style.textAlign = 'right';
          tdElement.style.color = '#ff0000';
          tdElement.style.fontWeight = 'bold';
        }
      });

      // Style footer cells
      const footerCells = tableClone.querySelectorAll('tfoot td');
      footerCells.forEach((cell) => {
        const tdElement = cell as HTMLElement;
        tdElement.style.padding = '8px';
        tdElement.style.fontWeight = 'bold';
        tdElement.style.border = '1px solid #333';
        tdElement.style.backgroundColor = '#1a1a1a';
        tdElement.style.color = '#ff0000';
        tdElement.style.textAlign = 'right';
      });

      wrapper.appendChild(tableClone);

      // Add footer info
      const footerDiv = document.createElement('div');
      footerDiv.innerHTML = `
        <hr style="border: none; border-top: 2px solid #0066cc; margin: 15px 0;">
        <div style="color: #0066cc; font-weight: bold; font-size: 13px; margin-bottom: 10px;">
          Total P/L: ${this.resultPl?.['CalculateBalance'] || '0'}
        </div>
        <div style="color: #999; font-size: 10px;">
          Generated on: ${moment().format('YYYY-MM-DD HH:mm:ss')}
        </div>
      `;
      wrapper.appendChild(footerDiv);

      // Add temporary wrapper to DOM
      document.body.appendChild(wrapper);

      // Dynamically load html2canvas library
      const script = document.createElement('script');
      script.src =
        'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
      script.onload = () => {
        (window as any)
          .html2canvas(wrapper, {
            scale: 2,
            useCORS: true,
            logging: false,
            backgroundColor: '#ffffff',
            allowTaint: true,
          })
          .then((canvas: HTMLCanvasElement) => {
            // Create PDF from canvas
            const pdf = new (jspdf as any).jsPDF('p', 'mm', 'a4');
            const imgData = canvas.toDataURL('image/png');
            const imgWidth = 210;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;

            // Add image to PDF with proper scaling
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= 297;

            while (heightLeft > 0) {
              position = heightLeft - imgHeight;
              pdf.addPage();
              pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
              heightLeft -= 297;
            }

            // Save PDF
            const fileName = `settlement_report_${moment().format('YYYY-MM-DD_HHmmss')}.pdf`;
            pdf.save(fileName);

            // Remove wrapper from DOM
            document.body.removeChild(wrapper);
            document.head.removeChild(script);

            this.spinnerService.hide();
            this.showToster(
              'Success',
              'success',
              'PDF downloaded successfully',
            );
          })
          .catch((error: any) => {
            document.body.removeChild(wrapper);
            document.head.removeChild(script);
            console.error('Error converting to canvas:', error);
            this.spinnerService.hide();
            this.showToster('Error', 'error', 'Error generating PDF');
          });
      };

      script.onerror = () => {
        document.body.removeChild(wrapper);
        this.spinnerService.hide();
        this.showToster('Error', 'error', 'Could not load html2canvas library');
      };

      document.head.appendChild(script);
    } catch (error) {
      console.error('Error generating PDF:', error);
      this.spinnerService.hide();
      this.showToster('Error', 'error', 'Error: ' + error.message);
    }
  }

  downloadAsExcel() {
    try {
      this.spinnerService.show();
      const element = document.getElementById('htmlData');

      if (!element) {
        this.showToster('Error', 'error', 'Table element not found');
        this.spinnerService.hide();
        return;
      }

      const table = element as HTMLTableElement;
      const rows = table.querySelectorAll('tr');

      if (rows.length === 0) {
        this.spinnerService.hide();
        this.showToster('Error', 'error', 'No data to export');
        return;
      }

      // Call the create Excel file function
      this.createExcelFile(table);
    } catch (error) {
      console.error('Error generating Excel:', error);
      this.spinnerService.hide();
      this.showToster('Error', 'error', 'Error: ' + error.message);
    }
  }

  createExcelFile(table: HTMLTableElement) {
    try {
      // Prepare data
      const data = [];

      // Add title
      data.push(['Settlement Report']);
      data.push(['Badla: ' + (this.badlaTitle || '')]);
      data.push([]);

      // Add headers
      const headerRow = [];
      const headerCells = table.querySelectorAll('thead th');
      headerCells.forEach((cell) => {
        headerRow.push(cell.textContent?.trim() || '');
      });
      data.push(headerRow);

      // Add body rows - properly extract only 3 columns
      const bodyRows = Array.from(table.querySelectorAll('tbody tr'));
      bodyRows.forEach((row) => {
        const cells = row.querySelectorAll('td');

        if (cells.length >= 3) {
          // Extract only the first 3 columns (Date, Particular, Amount)
          const dateText = cells[0].textContent?.trim() || '';
          const particularText = cells[1].textContent?.trim() || '';
          const amountText = cells[2].textContent?.trim() || '';

          data.push([dateText, particularText, amountText]);
        }
      });

      // Add empty row
      data.push([]);

      // Add total
      if (this.resultPl && this.resultPl['CalculateBalance']) {
        data.push(['Total P/L', '', this.resultPl['CalculateBalance']]);
      }

      // Add footer info
      data.push(['Generated on: ' + moment().format('YYYY-MM-DD HH:mm:ss')]);

      // Create worksheet from array of arrays
      const ws = XLSX.utils.aoa_to_sheet(data);

      // Set column widths
      ws['!cols'] = [{ wch: 25 }, { wch: 70 }, { wch: 20 }];

      // Define styles to match website
      // Header style - Cyan background with white text
      const headerStyle = {
        fill: { fgColor: { rgb: 'FF00BCD4' } },
        font: { bold: true, color: { rgb: 'FFFFFFFF' }, size: 11 },
        alignment: { horizontal: 'left', vertical: 'center', wrapText: true },
        border: {
          left: { style: 'thin', color: { rgb: 'FF333333' } },
          right: { style: 'thin', color: { rgb: 'FF333333' } },
          top: { style: 'thin', color: { rgb: 'FF333333' } },
          bottom: { style: 'thin', color: { rgb: 'FF333333' } },
        },
      };

      // Body cell style - Dark background with white text
      const bodyStyle = {
        fill: { fgColor: { rgb: 'FF1a1a1a' } },
        font: { color: { rgb: 'FFFFFFFF' }, size: 10 },
        alignment: { horizontal: 'left', vertical: 'center', wrapText: true },
        border: {
          left: { style: 'thin', color: { rgb: 'FF333333' } },
          right: { style: 'thin', color: { rgb: 'FF333333' } },
          top: { style: 'thin', color: { rgb: 'FF333333' } },
          bottom: { style: 'thin', color: { rgb: 'FF333333' } },
        },
      };

      // Amount cell style - Dark background with RED text
      const amountStyle = {
        fill: { fgColor: { rgb: 'FF1a1a1a' } },
        font: { color: { rgb: 'FFFF0000' }, size: 10, bold: true },
        alignment: { horizontal: 'right', vertical: 'center', wrapText: true },
        border: {
          left: { style: 'thin', color: { rgb: 'FF333333' } },
          right: { style: 'thin', color: { rgb: 'FF333333' } },
          top: { style: 'thin', color: { rgb: 'FF333333' } },
          bottom: { style: 'thin', color: { rgb: 'FF333333' } },
        },
      };

      // Total row style
      const totalStyle = {
        fill: { fgColor: { rgb: 'FF1a1a1a' } },
        font: { color: { rgb: 'FFFF0000' }, size: 11, bold: true },
        alignment: { horizontal: 'right', vertical: 'center' },
        border: {
          left: { style: 'medium', color: { rgb: 'FF00BCD4' } },
          right: { style: 'medium', color: { rgb: 'FF00BCD4' } },
          top: { style: 'medium', color: { rgb: 'FF00BCD4' } },
          bottom: { style: 'medium', color: { rgb: 'FF00BCD4' } },
        },
      };

      // Apply styles
      // Style header row (row 3, after title rows)
      for (let i = 0; i < 3; i++) {
        const cellAddress = XLSX.utils.encode_cell({ r: 3, c: i });
        ws[cellAddress] = ws[cellAddress] || {};
        ws[cellAddress].s = headerStyle;
      }

      // Style body rows
      const rows = data.length;
      for (let rowIndex = 4; rowIndex < rows - 2; rowIndex++) {
        for (let colIndex = 0; colIndex < 3; colIndex++) {
          const cellAddress = XLSX.utils.encode_cell({
            r: rowIndex,
            c: colIndex,
          });
          ws[cellAddress] = ws[cellAddress] || {};

          if (colIndex === 2) {
            // Amount column - red text
            ws[cellAddress].s = amountStyle;
          } else {
            // Date and Particular columns
            ws[cellAddress].s = bodyStyle;
          }
        }
      }

      // Style total row
      for (let i = 0; i < 3; i++) {
        const cellAddress = XLSX.utils.encode_cell({ r: rows - 2, c: i });
        ws[cellAddress] = ws[cellAddress] || {};
        ws[cellAddress].s = totalStyle;
      }

      // Set row heights for better appearance
      ws['!rows'] = [];
      for (let i = 0; i < rows; i++) {
        ws['!rows'][i] = { hpt: 20 };
      }

      // Create workbook and add sheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Settlement Report');

      // Generate Excel file
      const fileName = `settlement_report_${moment().format('YYYY-MM-DD_HHmmss')}.xlsx`;
      XLSX.writeFile(wb, fileName);

      this.spinnerService.hide();
      this.showToster(
        'Success',
        'success',
        'Excel file downloaded successfully',
      );
    } catch (error) {
      console.error('Error creating Excel file:', error);
      this.spinnerService.hide();
      this.showToster(
        'Error',
        'error',
        'Error creating Excel file: ' + error.message,
      );
    }
  }
}
